import { useEffect, useRef } from "react";

interface GoogleAdUnitProps {
  slot: string;
  format?: string;
  layout?: string;
  fullWidthResponsive?: boolean;
  className?: string;
}

const AD_CLIENT = "ca-pub-4996401652020047";

const GoogleAdUnit = ({
  slot,
  format = "auto",
  layout,
  fullWidthResponsive = true,
  className,
}: GoogleAdUnitProps) => {
  const pushed = useRef(false);

  useEffect(() => {
    if (pushed.current) return;
    pushed.current = true;
    try {
      ((window as unknown as { adsbygoogle?: unknown[] }).adsbygoogle =
        (window as unknown as { adsbygoogle?: unknown[] }).adsbygoogle || []).push({});
    } catch {
      // AdSense not available (blocked or offline)
    }
  }, []);

  const isInArticle = layout === "in-article" || format === "fluid";

  return (
    <div className={className}>
      <ins
        className="adsbygoogle"
        style={isInArticle ? { display: "block", textAlign: "center" } : { display: "block" }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        {...(layout ? { "data-ad-layout": layout } : {})}
        {...(isInArticle ? {} : { "data-full-width-responsive": fullWidthResponsive ? "true" : "false" })}
      />
    </div>
  );
};

export default GoogleAdUnit;
